import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { Observable, Subject } from "rxjs";

import { AppModule } from "../../../app.module";

export class ApplicationLoaderService {
    private static _instance: ApplicationLoaderService;

    private _onReboot: Subject<boolean> = new Subject();

    public static instance(): ApplicationLoaderService {
        if (!this._instance) {
            this._instance = new ApplicationLoaderService();
        }

        return this._instance;
    }

    public boot(): void {
        platformBrowserDynamic().bootstrapModule(AppModule).catch(error => console.error(error));
    }

    public reboot(): void {
        this._onReboot.next(true);
    }

    public onReboot(): Observable<boolean> {
        return this._onReboot.asObservable();
    }
}
